<div class="api-card key-overview-card">

  <div class="api-card__header">
    <div class="key-overview-card__header-left">
      <span class="key-overview-card__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.75 1.5C12.0221 1.5 9 4.52208 9 8.25C9 8.64372 9.03379 9.03016 9.0988 9.40639C9.16599 9.79527 9.06678 10.1226 8.87767 10.3117L2.37868 16.8107C1.81607 17.3733 1.5 18.1363 1.5 18.932V21.75C1.5 22.1642 1.83579 22.5 2.25 22.5H6C6.41421 22.5 6.75 22.1642 6.75 21.75V20.25H8.25C8.66421 20.25 9 19.9142 9 19.5V18H10.5C10.6989 18 10.8897 17.921 11.0303 17.7803L13.6883 15.1223C13.8774 14.9332 14.2047 14.834 14.5936 14.9012C14.9698 14.9662 15.3563 15 15.75 15C19.4779 15 22.5 11.9779 22.5 8.25C22.5 4.52208 19.4779 1.5 15.75 1.5ZM15.75 4.5C15.3358 4.5 15 4.83579 15 5.25C15 5.66421 15.3358 6 15.75 6C16.9926 6 18 7.00736 18 8.25C18 8.66421 18.3358 9 18.75 9C19.1642 9 19.5 8.66421 19.5 8.25C19.5 6.17893 17.8211 4.5 15.75 4.5Z" fill="currentColor"/>
        </svg>
      </span>
      <div class="key-overview-card__header-text">
        <span class="key-overview-card__title">API keys</span>
        <span class="key-overview-card__subtitle">Keys that can call the API right now.</span>
      </div>
    </div>
  </div>

  <div class="key-overview-card__middle">

    <div class="key-overview-card__body">
      <div class="key-overview-card__col">
        <span class="key-overview-card__label">Active keys</span>
        <span class="key-overview-card__big-number">{{ summary.activeCount }}</span>
      </div>

      <div class="key-overview-card__col-divider"></div>

      <div class="key-overview-card__col">
        <span class="key-overview-card__label">Most recently used</span>
        @if (summary.mostRecentlyUsed; as recent) {
          <div class="key-overview-card__key-pill">
            <!-- No copy button here on purpose: this card only ever has
                 the masked prefix (see api-keys-summary-card.ts /
                 OverviewApiKeysSummary), never the real key a copy icon
                 next to it would look functional but copy something
                 unusable as an actual key. Getting the real value is
                 what the API Keys page's own reveal action is for. -->
            <span class="key-overview-card__key-value">{{ recent.namePrefix }}</span>
          </div>
          <span class="key-overview-card__caption">Used {{ timeAgo(recent.usedAt) }}</span>
        } @else {
          <span class="key-overview-card__caption">No key has made a call yet.</span>
        }
      </div>
    </div>

    <div class="key-overview-card__actions">
      <a routerLink="/api-keys/create" class="key-overview-card__create-btn">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M8 2.5C8.27614 2.5 8.5 2.72386 8.5 3V7.5H13C13.2761 7.5 13.5 7.72386 13.5 8C13.5 8.27614 13.2761 8.5 13 8.5H8.5V13C8.5 13.2761 8.27614 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13V8.5H3C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.72386 2.72386 7.5 3 7.5H7.5V3C7.5 2.72386 7.72386 2.5 8 2.5Z" fill="currentColor"/>
        </svg>
        Create new key
      </a>
    </div>

  </div>

  <div class="api-card__footer">
    <a routerLink="/api-keys" class="link">
      View all API keys
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M4.5 2.5L8 6L4.5 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
  </div>

</div>
